export const SET_PAGE_CONTENT = 'SIGNUP.SET_PAGE_CONTENT'
export const SET_ACTIVE_STEP = 'SIGNUP.SET_ACTIVE_STEP'
export const SET_SIGNUP_ROUTES = 'SIGNUP.SET_SIGNUP_ROUTES'
export const SET_NEXT_ACTION = 'SIGNUP.SET_NEXT_ACTION'
export const SET_AB_TEST_TRACKED = 'SIGNUP.SET_AB_TEST_TRACKED'
